import { ApiClient } from "./ApiClient";

export default {
  install(Vue) {
    Vue.prototype.$api = new ApiClient();
    Vue.api = Vue.prototype.$api;
  },
};
